import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Long2qws0ah9gnpki as Long,
  Unit_instanceat14thlj150z as Unit_instance,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  protoOf180f3jzyo7rfj as protoOf,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  createFailure8paxfkfa5dc7 as createFailure,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  Key_instance3trehy4y6zgij as Key_instance,
  getxe4seun860fg as get_0,
  minusKey2uxs00uz5ceqp as minusKey_0,
  releaseInterceptedContinuation17jnf0xkuoovi as releaseInterceptedContinuation,
  ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor,
  Result__exceptionOrNull_impl_p6xea93g9kuxe56cw2k as Result__exceptionOrNull_impl_p6xea9,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqgbxrwpgk5sesh as _Result___get_value__impl__bjfvqg,
  printStackTrace18lnx7a39cni as printStackTrace,
  println2shhhgwwt4c61 as println,
  lazy2hsh8ze7j6ikd as lazy,
} from './kotlin-kotlin-stdlib.mjs';
import {
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
} from './kotlinx-atomicfu.mjs';
import {
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  invokeOnTimeout3llts2igdsa63 as invokeOnTimeout,
  Delay9umexudtwyie as Delay,
} from './kotlinx-coroutines-core.mjs';
import { FastArrayListw5fr1wlp4slq as FastArrayList } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class NonRecursiveLock {
  constructor() {
    this.y1v_1 = new Object();
  }
}
class BaseLockWithNotifyAndWait {}
function notify$default(unit, $super) {
  unit = unit === VOID ? Unit_instance : unit;
  var tmp;
  if ($super === VOID) {
    this.g1w(unit);
    tmp = Unit_instance;
  } else {
    var tmp_0 = $super.g1w;
    tmp = tmp_0.call(this, Unit_instance);
  }
  return tmp;
}
class LockImpl {
  constructor() {
    this.z1v_1 = atomic$boolean$1(false);
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.a1w_1 = get_atomicfu$reentrantLock();
    this.b1w_1 = atomic$long$1(new Long(0, 0));
    this.c1w_1 = atomic$int$1(0);
  }
  d1w() {
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.lock' call
    this.a1w_1;
    this.c1w_1.atomicfu$incrementAndGet();
    this.b1w_1.kotlinx$atomicfu$value = _NativeThread___get_id__impl__jog4wy(Companion_instance_0.e1w());
  }
  f1w() {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.c1w_1.kotlinx$atomicfu$value > 0)) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.unlock.<anonymous>' call
      var message = 'Must unlock inside a synchronization block';
      throw IllegalStateException.s4(toString(message));
    }
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.unlock' call
    this.a1w_1;
    this.c1w_1.atomicfu$decrementAndGet();
  }
  g1w(unit) {
    if (!get_isSupported(Companion_instance_2))
      throw UnsupportedOperationException.x7();
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.c1w_1.kotlinx$atomicfu$value > 0)) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.notify.<anonymous>' call
      var message = 'Must notify inside a synchronization block';
      throw IllegalStateException.s4(toString(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.b1w_1.kotlinx$atomicfu$value.equals(_NativeThread___get_id__impl__jog4wy(Companion_instance_0.e1w()))) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.notify.<anonymous>' call
      var message_0 = 'Must lock the notify thread';
      throw IllegalStateException.s4(toString(message_0));
    }
    this.z1v_1.kotlinx$atomicfu$value = true;
  }
}
class Companion {
  i1w() {
    return get_NativeThreadThread_isSupported();
  }
  e1w() {
    return _NativeThread___init__impl__p2udts(NativeThreadThread_current());
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    this.j1w_1 = new PreferSyncIo(true);
    this.k1w_1 = new PreferSyncIo(false);
  }
  l1w(preferSyncIo) {
    return preferSyncIo === true ? this.j1w_1 : this.k1w_1;
  }
}
class PreferSyncIo {
  constructor(preferSyncIo) {
    Companion_getInstance_0();
    this.m1w_1 = preferSyncIo;
  }
  n1() {
    return Companion_getInstance_0();
  }
  toString() {
    return 'PreferSyncIo(preferSyncIo=' + this.m1w_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.m1w_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreferSyncIo))
      return false;
    var tmp0_other_with_cast = other instanceof PreferSyncIo ? other : THROW_CCE();
    if (!(this.m1w_1 === tmp0_other_with_cast.m1w_1))
      return false;
    return true;
  }
}
class BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = BaseSignal$_init_$lambda_tuu04y;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    this.s1w_1 = onRegister;
    this.t1w_1 = FastArrayList.r1j();
    this.u1w_1 = FastArrayList.r1j();
    this.v1w_1 = 0;
  }
  e1x() {
    return this.t1w_1.d1();
  }
  f1x() {
    return this.e1x() > 0;
  }
  w1w(once, handler) {
    this.s1w_1();
    var node = new Node(this, once, handler);
    this.t1w_1.h(node);
    return node;
  }
}
class Signal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = Signal$_init_$lambda_6vimhp;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  r1w(handler) {
    return this.w1w(true, handler);
  }
  x1w(handler) {
    return this.w1w(false, handler);
  }
  y1w(handler) {
    return this.x1w(handler);
  }
  z1w(value) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
      if (this.t1w_1.g1()) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
      try {
        this.v1w_1 = this.v1w_1 + 1 | 0;
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_0 = this.t1w_1;
        var n = 0;
        var m = 0;
        while (n < this_0.d1()) {
          if (m >= 0 && !(m === n)) {
            this_0.z2(m, this_0.f1(n));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var node = this_0.f1(n);
          var remove = node.a1x_1;
          // Inline function 'korlibs.io.async.Signal.invoke.<anonymous>' call
          node.b1x_1(value);
          if (remove) {
            m = m - 1 | 0;
          }
          n = n + 1 | 0;
          m = m + 1 | 0;
        }
        while (this_0.d1() > m) {
          this_0.a3(this_0.d1() - 1 | 0);
        }
      }finally {
        this.v1w_1 = this.v1w_1 - 1 | 0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.u1w_1.g1()) {
          // Inline function 'korlibs.io.async.fastIterateRemove' call
          var this_1 = this.u1w_1;
          var n_0 = 0;
          var m_0 = 0;
          while (n_0 < this_1.d1()) {
            if (m_0 >= 0 && !(m_0 === n_0)) {
              this_1.z2(m_0, this_1.f1(n_0));
            }
            // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
            var it = this_1.f1(n_0);
            this.t1w_1.x2(it);
            if (true) {
              m_0 = m_0 - 1 | 0;
            }
            n_0 = n_0 + 1 | 0;
            m_0 = m_0 + 1 | 0;
          }
          while (this_1.d1() > m_0) {
            this_1.a3(this_1.d1() - 1 | 0);
          }
        }
      }
    }
    return tmp$ret$0;
  }
  d1x($completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.uw();
    // Inline function 'korlibs.io.async.Signal.waitOneBase.<anonymous>' call
    var close = {_v: null};
    close._v = this.r1w(Signal$waitOneBase$lambda(close, cancellable));
    cancellable.cv(Signal$waitOneBase$lambda_0(close));
    return cancellable.gu();
  }
}
class AsyncSignal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = AsyncSignal$_init_$lambda_rsv6fb;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  k1x(value, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, value), $completion);
  }
}
class Node {
  constructor($outer, once, item) {
    this.c1x_1 = $outer;
    this.a1x_1 = once;
    this.b1x_1 = item;
  }
  y5() {
    if (this.c1x_1.v1w_1 > 0) {
      this.c1x_1.u1w_1.h(this);
    } else {
      this.c1x_1.t1w_1.x2(this);
    }
  }
}
class runBlockingNoSuspensions$1$context$1 extends AbstractCoroutineContextElement {
  static o1x($suspendCount, $box) {
    if ($box === VOID)
      $box = {};
    $box.n1x_1 = $suspendCount;
    var $this = this.vm(Key_instance, $box);
    $this.m1x_1 = Key_instance;
    return $this;
  }
  n1() {
    return this.m1x_1;
  }
  zc(continuation) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.async.<no name provided>.interceptContinuation.<anonymous>' call
    var _unary__edvuaz = this.n1x_1._v;
    this.n1x_1._v = _unary__edvuaz + 1 | 0;
    return continuation;
  }
  ez(timeMillis, continuation) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    continuation.nc(tmp$ret$0);
    return Unit_instance;
  }
}
class runBlockingNoSuspensions$1 {
  constructor($suspendCount, $resultEx, $completed, $rresult) {
    this.q1x_1 = $resultEx;
    this.r1x_1 = $completed;
    this.s1x_1 = $rresult;
    var tmp = this;
    tmp.p1x_1 = runBlockingNoSuspensions$1$context$1.o1x($suspendCount);
  }
  lc() {
    return this.p1x_1;
  }
  t1x(result) {
    var exception = Result__exceptionOrNull_impl_p6xea9(result);
    if (!(exception == null)) {
      this.q1x_1._v = exception;
      this.r1x_1._v = true;
      printStackTrace(exception);
    } else {
      // Inline function 'kotlin.getOrThrow' call
      throwOnFailure(result);
      var tmp = _Result___get_value__impl__bjfvqg(result);
      var tmp0_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        _get_unitInstance__yoa8mq(this);
        var tmp_1 = Unit_instance;
        var tmp_2;
        if (!(Unit_instance == null)) {
          tmp_2 = Unit_instance;
        } else {
          tmp_2 = THROW_CCE();
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var rvalue = tmp_0;
      this.s1x_1._v = rvalue;
      this.r1x_1._v = true;
    }
  }
  nc(result) {
    return this.t1x(result);
  }
}
class Companion_1 {}
class Lock extends LockImpl {}
//endregion
function get_isSupported(_this__u8e3s4) {
  return Companion_instance_0.i1w();
}
function _NativeThread___init__impl__p2udts(native) {
  return native;
}
function _NativeThread___get_native__impl__f44o82($this) {
  return $this;
}
function _NativeThread___get_id__impl__jog4wy($this) {
  return NativeNativeThread_getId(_NativeThread___get_native__impl__f44o82($this));
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
function Signal$_init_$lambda_6vimhp() {
  return Unit_instance;
}
function Signal$waitOneBase$lambda($close, $c) {
  return function (it) {
    var tmp12_safe_receiver = $close._v;
    if (tmp12_safe_receiver == null)
      null;
    else {
      tmp12_safe_receiver.y5();
    }
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
    this_0.nc(tmp$ret$0);
    return Unit_instance;
  };
}
function Signal$waitOneBase$lambda_0($close) {
  return function (it) {
    var tmp13_safe_receiver = $close._v;
    if (tmp13_safe_receiver == null)
      null;
    else {
      tmp13_safe_receiver.y5();
    }
    return Unit_instance;
  };
}
function invoke(_this__u8e3s4) {
  return _this__u8e3s4.z1w(Unit_instance);
}
function waitOne(_this__u8e3s4, $completion) {
  return _this__u8e3s4.d1x($completion);
}
function *_generator_invoke__zhh2q8($this, value, $completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
    if ($this.t1w_1.g1()) {
      break $l$block;
    }
    try {
      $this.v1w_1 = $this.v1w_1 + 1 | 0;
      // Inline function 'korlibs.io.async.fastIterateRemove' call
      var this_0 = $this.t1w_1;
      var n = 0;
      var m = 0;
      while (n < this_0.d1()) {
        if (m >= 0 && !(m === n)) {
          this_0.z2(m, this_0.f1(n));
        }
        // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
        var node = this_0.f1(n);
        var remove = node.a1x_1;
        // Inline function 'korlibs.io.async.AsyncSignal.invoke.<anonymous>' call
        var tmp = node.b1x_1(value, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        if (remove) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.d1() > m) {
        this_0.a3(this_0.d1() - 1 | 0);
      }
    }finally {
      $this.v1w_1 = $this.v1w_1 - 1 | 0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$this.u1w_1.g1()) {
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_1 = $this.u1w_1;
        var n_0 = 0;
        var m_0 = 0;
        while (n_0 < this_1.d1()) {
          if (m_0 >= 0 && !(m_0 === n_0)) {
            this_1.z2(m_0, this_1.f1(n_0));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var it = this_1.f1(n_0);
          $this.t1w_1.x2(it);
          if (true) {
            m_0 = m_0 - 1 | 0;
          }
          n_0 = n_0 + 1 | 0;
          m_0 = m_0 + 1 | 0;
        }
        while (this_1.d1() > m_0) {
          this_1.a3(this_1.d1() - 1 | 0);
        }
      }
    }
  }
  return Unit_instance;
}
function AsyncSignal$_init_$lambda_rsv6fb() {
  return Unit_instance;
}
function BaseSignal$_init_$lambda_tuu04y() {
  return Unit_instance;
}
function runBlockingNoSuspensions(callback) {
  var completed = {_v: false};
  var rresult = {_v: null};
  var resultEx = {_v: null};
  var suspendCount = {_v: 0};
  startCoroutineUndispatched(callback, new runBlockingNoSuspensions$1(suspendCount, resultEx, completed, rresult));
  if (!completed._v)
    throw IllegalStateException.s4('runBlockingNoSuspensions was not completed synchronously! suspendCount=' + suspendCount._v);
  if (!(resultEx._v == null))
    throw ensureNotNull(resultEx._v);
  var tmp;
  if (rresult._v == null) {
    throwUninitializedPropertyAccessException('rresult');
  } else {
    tmp = rresult._v;
  }
  return tmp;
}
function startCoroutineUndispatched(_this__u8e3s4, completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.startDirect' call
    var tmp;
    try {
      // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>' call
      // Inline function 'korlibs.io.async.withCoroutineContext' call
      completion.lc();
      // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
      tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(e));
        completion.nc(tmp$ret$4);
        break $l$block;
      } else {
        throw $p;
      }
    }
    var value = tmp;
    if (!(value === get_COROUTINE_SUSPENDED())) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
      var tmp$ret$7 = _Result___init__impl__xyqfz8(value_0);
      completion.nc(tmp$ret$7);
    }
  }
}
function _get_unitInstance__yoa8mq($this) {
  return Unit_instance;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
function get_NativeThreadThread_isSupported() {
  _init_properties_NativeThread_js_kt__xin1zw();
  return NativeThreadThread_isSupported;
}
var NativeThreadThread_isSupported;
var warnSleep$delegate;
function NativeNativeThread_getId(thread) {
  _init_properties_NativeThread_js_kt__xin1zw();
  return new Long(0, 0);
}
function NativeThreadThread_current() {
  _init_properties_NativeThread_js_kt__xin1zw();
  return new Long(0, 0);
}
function warnSleep$delegate$lambda() {
  _init_properties_NativeThread_js_kt__xin1zw();
  println('!!! Sync sleeping on JS');
  return Unit_instance;
}
var properties_initialized_NativeThread_js_kt_lgs6ti;
function _init_properties_NativeThread_js_kt__xin1zw() {
  if (!properties_initialized_NativeThread_js_kt_lgs6ti) {
    properties_initialized_NativeThread_js_kt_lgs6ti = true;
    NativeThreadThread_isSupported = false;
    warnSleep$delegate = lazy(warnSleep$delegate$lambda);
  }
}
//region block: post-declaration
initMetadataForClass(NonRecursiveLock, 'NonRecursiveLock', NonRecursiveLock);
initMetadataForInterface(BaseLockWithNotifyAndWait, 'BaseLockWithNotifyAndWait');
protoOf(LockImpl).h1w = notify$default;
initMetadataForClass(LockImpl, 'LockImpl', VOID, VOID, [BaseLockWithNotifyAndWait]);
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
protoOf(PreferSyncIo).yc = get;
protoOf(PreferSyncIo).pm = fold;
protoOf(PreferSyncIo).om = minusKey;
protoOf(PreferSyncIo).qm = plus;
initMetadataForClass(PreferSyncIo, 'PreferSyncIo', VOID, VOID, [Element]);
initMetadataForClass(BaseSignal, 'BaseSignal', VOID, VOID, VOID, [0]);
initMetadataForClass(Signal, 'Signal', Signal, VOID, VOID, [0]);
initMetadataForClass(AsyncSignal, 'AsyncSignal', AsyncSignal, VOID, VOID, [1, 0]);
initMetadataForClass(Node, 'Node', VOID, VOID, [AutoCloseable]);
protoOf(runBlockingNoSuspensions$1$context$1).yc = get_0;
protoOf(runBlockingNoSuspensions$1$context$1).om = minusKey_0;
protoOf(runBlockingNoSuspensions$1$context$1).ad = releaseInterceptedContinuation;
protoOf(runBlockingNoSuspensions$1$context$1).fz = invokeOnTimeout;
initMetadataForClass(runBlockingNoSuspensions$1$context$1, VOID, VOID, VOID, [AbstractCoroutineContextElement, ContinuationInterceptor, Delay], [1]);
initMetadataForClass(runBlockingNoSuspensions$1);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Lock, 'Lock', Lock, VOID, [LockImpl, BaseLockWithNotifyAndWait]);
//endregion
//region block: init
Companion_instance_0 = new Companion();
Companion_instance_2 = new Companion_1();
//endregion
//region block: exports
export {
  waitOne as waitOne62vo52xwwewy,
  Companion_getInstance_0 as Companion_getInstancet6d3dkp9rzuf,
  Lock as Lock5n7hh3dgcidl,
  NonRecursiveLock as NonRecursiveLock2vf7fkhp857q,
  AsyncSignal as AsyncSignal3p186s2w7f15b,
  Signal as Signal3nnez3346azzf,
  invoke as invoke2sf88d1xeuyqh,
  runBlockingNoSuspensions as runBlockingNoSuspensions25hsuevf2mle,
};
//endregion
